/** @jsx jsx */
import ensureSignedIn from "gatsby-plugin-hfn-profile/auth/ensureSignedIn";
import Home from "../care-app/Home";

export default ensureSignedIn(Home);
